import React, { Component } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js'
import { learnerTypeColors } from '../utils'

// Register necessary elements
Chart.register(ArcElement, Tooltip, Legend)

class LearnerTypeChart extends Component {
  render() {
    const { questions } = this.props

    const options = {
      cutout: '50%', // Replaces percentageInnerCutout
      borderWidth: 0, // Replaces segmentShowStroke
      animation: {
        animateRotate: false,
        animateScale: false,
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false, // Replaces showTooltips
        },
      },
      maintainAspectRatio: false,
    }

    let percentages = {}
    let percentage

    let data = Object.keys(learnerTypeColors).map((learnerType) => {
      const numWithType = questions.filter(
        (q) => q.question.learnerType === learnerType
      ).length

      if (questions.length === 0) {
        percentage = 0
      } else {
        percentage = ((numWithType / questions.length) * 100.0).toFixed(1)
      }
      percentages[learnerType] = percentage

      return {
        value: numWithType,
        color: learnerTypeColors[learnerType],
        label: learnerType,
      }
    })

    let labels = []
    let backgroundColor = []
    let dataset = []

    data.forEach((set) => {
      dataset.push(set.value)
      backgroundColor.push(set.color)
      labels.push(set.label)
    })

    const dataobj = {
      labels: labels,
      datasets: [
        {
          data: dataset,
          backgroundColor: backgroundColor,
        },
      ],
    }

    return (
      <div className="learner-type-chart">
        <div className="chart-container">
          <Doughnut data={dataobj} options={options} />
        </div>
        <div className="legend">
          <h5>Learner Profile:</h5>
          {Object.keys(learnerTypeColors).map((learnerType) => (
            <div key={learnerType} className="legend-item">
              <div
                className="legend-circle"
                style={{ backgroundColor: learnerTypeColors[learnerType] }}
              />
              {learnerType}: {percentages[learnerType]}%
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default LearnerTypeChart
